/*
const colors = [
  new THREE.Color(0x3344ee),
  new THREE.Color(0x33ee44),
  new THREE.Color(0xee3344),
  new THREE.Color(0xdd44dd),
  new THREE.Color(0x5522cc)
]
*/

const colors = [
  new THREE.Color(0x333333)
];

export default class GHLinePath extends THREE.Line {
  constructor (paths) {
    const geom = new THREE.Geometry();
    for (let i = 0, n = paths.length; i < n; i++) {
      let p0 = paths[i];
      let v0 = new THREE.Vector3(p0.X, p0.Y, 0);
      // let v1 = paths[(i + 1) % n]
      // geom.vertices.push(v0, v1)
      geom.vertices.push(v0);
    }

    super(
      geom,
      new THREE.LineBasicMaterial({
        color: new THREE.Color(0xff0000)
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/GHLinePath.js